module.exports = __webpack_public_path__ + "img/CA-NPDC.badfdd05.jpg";